// BillingPageSkeleton.jsx — mirrors the real billing layout so the swap is quiet
import React from "react";
import "../../account.css";
import "../accountBillingPage.css";
import "./billingPageSkeleton.css";

const BillingPageSkeleton = () => {
	return (
		<div className="ac-page">
			<div className="apb-skel-head">
				<div className="apb-skel-line shimmer w-30" />
				<div className="apb-skel-line shimmer w-60 is-title" />
			</div>

			<div className="apb-grid">
				{/* MAIN COLUMN */}
				<div className="apb-col">
					<div className="ac-card">
						<div className="ac-card-head">
							<div className="apb-skel-icon shimmer" />
							<div className="apb-skel-line shimmer w-40" />
							<div className="apb-skel-badge shimmer" />
						</div>

						<div className="ac-card-body">
							<div className="apb-skel-amount shimmer" />
							<div className="apb-skel-line shimmer w-50" />
							<div className="apb-skel-box shimmer" />
							<div className="apb-skel-actions">
								<div className="apb-skel-btn shimmer" />
								<div className="apb-skel-btn shimmer" />
							</div>
						</div>
					</div>

					<div className="ac-card">
						<div className="ac-card-head">
							<div className="apb-skel-icon shimmer" />
							<div className="apb-skel-line shimmer w-50" />
						</div>

						<div className="ac-card-body">
							<div className="apb-skel-line shimmer w-80" />
							<div className="apb-skel-line shimmer w-60" />
							<div className="apb-skel-line shimmer w-40" />
						</div>
					</div>
				</div>

				{/* SIDE COLUMN */}
				<div className="apb-col apb-col--side">
					<div className="ac-card">
						<div className="ac-card-head">
							<div className="apb-skel-icon shimmer" />
							<div className="apb-skel-line shimmer w-50" />
						</div>
						<div className="ac-card-body">
							<div className="apb-skel-box shimmer" />
						</div>
					</div>

					<div className="ac-card">
						<div className="ac-card-head">
							<div className="apb-skel-icon shimmer" />
							<div className="apb-skel-line shimmer w-40" />
						</div>
						<div className="ac-card-body">
							<div className="apb-skel-box shimmer" />
							<div className="apb-skel-line shimmer w-70" />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BillingPageSkeleton;
